export default __webpack_public_path__ + "static/media/Strom.b7b05296.svg";